export const enabledAuthProviders = ["github"] as const;

export type EnabledAuthProviderKind = (typeof enabledAuthProviders)[number];

// Overlord 가 발급한 access token 과 그 identity 스냅샷 — "허용 조직의 GitHub 사용자" 까지만 뜻한다.
// 이 조직의 Intake Member 인지는 `IntakeMembership`(`GET /v1/me`)이 따로 말한다(docs/api.md).
export type AuthSession = {
  provider: EnabledAuthProviderKind;
  // provider 가 보장하는 불변 사용자 식별자(GitHub 숫자 ID 문자열). Intake Member UUID 가 아니다.
  subject: string;
  // 변경 가능한 GitHub username. provider 가 주지 않으면 null.
  username: string | null;
  displayName: string;
  email: string | null;
  accessToken: string;
  accessTokenExpiresAt: string | null;
};

// Intake BE(spnp)가 `GET /v1/me` 로 확인해 준 이 세션의 조직 소속. Org/Member 만 있고 role 은 없다(명세 §5).
export type IntakeMembership = {
  organizationUuid: string;
  organizationName: string;
  memberUuid: string;
};
